import {
  Alert,
  Box,
  Button,
  Grid,
  Snackbar,
  Tooltip,
  useMediaQuery,
} from "@mui/material";
import axios from "axios";
import dayjs from "dayjs";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AccordianContainer from "../CustomComponents/AccordianContainer";
import CustomAutoComplete from "../CustomComponents/CustomAutoComplete";
import CustomDateField from "../CustomComponents/CustomDateField";
import GetBranchDetails from "../CustomComponents/GetBranchDetails";
import { BranchAction } from "../Store/Branch";
import { ChequeReturnReducerAction } from "../Store/ChequeReturnReducer";
import { CommonShortCutAction } from "../Store/CommonShortCutsReducer";

const ChequeReturnFilter = () => {
  const [branchArray, setBranchArray] = useState([]);

  //importing hook
  const dispatch = useDispatch();

  //Selectors from redux store
  const filteredData = useSelector((state) => state.chequeReturn.filterData);
  const datarows = useSelector((state) => state.chequeReturn.gridRows);
  const userName = useSelector((state) => state.branch.userName);

  //Input Validtion
  const branchValid =
    filteredData.branchValue !== undefined &&
    filteredData.branchValue !== "" &&
    filteredData.branchValue !== null;
  const voucherDateValid =
    filteredData.voucherDate !== undefined &&
    filteredData.voucherDate !== null &&
    filteredData.voucherDate !== "" &&
    new Date(filteredData.voucherDate).toDateString() !== "Invalid Date" &&
    new Date(filteredData.voucherDate) >= new Date("1970/01/01") &&
    new Date(filteredData.voucherDate) <= new Date();

  //Has Error
  const branchHasError = filteredData.branchTouch && !branchValid;
  const voucherDateHasError =
    filteredData.voucherDateTouch && !voucherDateValid;

  //SnackBar Handler
  const [message, setMessage] = useState("");
  const [alertType, setAlertType] = useState("success");
  const [snackBarState, setSnackBarState] = React.useState({
    vertical: "bottom",
    horizontal: "left",
  });
  const { vertical, horizontal } = snackBarState;
  const [alert, setAlert] = useState(false);

  const deviceModeValue = useMediaQuery("(max-width:1200px)");
  useEffect(() => {
    // true -> mobile or tab, false -> desktop
    let SnackPosition = {
      vertical: deviceModeValue ? "top" : "bottom",
      horizontal: deviceModeValue ? "right" : "left",
    };
    setSnackBarState(SnackPosition);
  }, []);

  //shortcut key

  const clearRef = useRef(null);
  const searchButtonRef = useRef(null);
  useEffect(() => {
    window.addEventListener("keydown", onKeyUnmountEventHandler);
    window.addEventListener("keyup", onKeyPressEventHandler);
    return () => {
      window.removeEventListener("keydown", onKeyUnmountEventHandler);
      window.removeEventListener("keyup", onKeyPressEventHandler);
    };
  }, []);
  const onKeyUnmountEventHandler = (event) => {
    if (event.ctrlKey) {
      dispatch(
        CommonShortCutAction.removeDefaultShortCutValue({
          event: event,
          screen: "chequeReturnFilter",
        })
      );
    }
  };
  const onKeyPressEventHandler = (event) => {
    let date = new Date();
    let charCode = String.fromCharCode(event.which).toLowerCase();
    if (event.ctrlKey) {
      if (charCode === "d") {
        clearRef.current.click();
      } else if (charCode === "f") {
        searchButtonRef.current.click();
      } else if (charCode === "i") {
        setVoucherDate(date);
      } else if (charCode === "p") {
        date.setDate(date.getDate() - 1);
        setVoucherDate(date);
      }
    }
  };

  useEffect(() => {
    // on load reset the values.
    ClearButtonHandler();
    const branchValues = GetBranchDetails();
    setBranchArray(branchValues);
    if (branchValues.length === 1) {
      branchOnChangeHandler(branchValues[0]);
    }
    // load the current date for the voucher date as default value.
    setVoucherDate(new Date());
  }, []);

  const openAlertHandler = () => {
    setAlert(true);
  };
  const closeAlertHandler = () => {
    setAlert(false);
  };

  const branchOnChangeHandler = (value) => {
    dispatch(ChequeReturnReducerAction.updateShowCheckReturnList(false));
    dispatch(ChequeReturnReducerAction.updateVoucherDateTouchHandler(false));
    dispatch(ChequeReturnReducerAction.resetGridRows());
    dispatch(BranchAction.updateInitialLoad(false));
    if (value) {
      dispatch(BranchAction.updateHeaderBranchDetails(value.label));
      dispatch(ChequeReturnReducerAction.updateBranchValue(value.label));
    } else {
      dispatch(ChequeReturnReducerAction.updateBranchValue(null));
    }
    dispatch(ChequeReturnReducerAction.updateVoucherDateValue(null));
  };

  const setBranchHasTouched = () => {
    dispatch(ChequeReturnReducerAction.updateBranchTouchHandler(true));
  };

  const setVoucherDate = (value) => {
    dispatch(ChequeReturnReducerAction.updateVoucherDateValue(value));
  };

  const ClearButtonHandler = () => {
    dispatch(ChequeReturnReducerAction.resetFilterValues());
    dispatch(ChequeReturnReducerAction.updateBranchTouchHandler(false));
    dispatch(ChequeReturnReducerAction.updateVoucherDateTouchHandler(false));
    dispatch(ChequeReturnReducerAction.updateShowCheckReturnList(false));
    dispatch(ChequeReturnReducerAction.resetGridRows());
  };

  const SearchButtonHandler = async () => {
    dispatch(ChequeReturnReducerAction.updateBranchTouchHandler(true));
    dispatch(ChequeReturnReducerAction.updateVoucherDateTouchHandler(true));
    if (branchValid && voucherDateValid) {
      dispatch(ChequeReturnReducerAction.updateVoucherDateDisabled(true));
      try {
        const response = await axios.post("/cheque/getChequeReturnReasons", {
          apiCode: "CHEQUE_RETURN_LOV_API",
          createdBy: userName,
          lastModifiedBy: userName,
        });
        if (Object.keys(response.data).length > 0) {
          if (Number(response.data.status) === 1) {
            const returnReasons = [...response.data.return_reasons]
              .filter((rec) => rec.reason_type === "CHQ")
              .map((reason) => {
                return {
                  key: reason.reason_code,
                  value: reason.reason_desc,
                  text: reason.reason_desc,
                  name: reason.reason_code,
                };
              });
            dispatch(
              ChequeReturnReducerAction.updateReturnReasonArray(returnReasons)
            );
          }
        }

        dispatch(ChequeReturnReducerAction.updateGridRows([]));
        dispatch(ChequeReturnReducerAction.updateShowCheckReturnList(true));
      } catch (error) {
        throw Error(error);
      }
    } else {
      return;
    }
  };

  return (
    <Box>
      <AccordianContainer
        id="accord"
        title="Cheque Return Process"
        initialOpen={true}
        sx={{ margin: "8px !important" }}
      >
        <Grid container spacing={1}>
          <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
            <CustomAutoComplete
              variant="standard"
              type="text"
              placeholder="Select Branch"
              label="Branch"
              required={true}
              autoCompleteValues={branchArray}
              value={filteredData.branchValue}
              onBlur={setBranchHasTouched}
              onChange={(event, newValue) => {
                branchOnChangeHandler(newValue);
              }}
            />
            {branchHasError && <p className="error">Please Select Branch</p>}
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
            <CustomDateField
              label="Voucher Date"
              variant="standard"
              required={true}
              value={filteredData.voucherDate}
              disabled={filteredData.voucherDateDisabled}
              minDate={new Date("1970/01/01")}
              maxDate={new Date()}
              onBlur={(value) => {
                // update the date format.
                const voucherDateString = value.target.value;
                const dateParts = voucherDateString.split("/");

                // month is 0-based, that's why we need dataParts[1] - 1
                const newValue = new Date(
                  +dateParts[2],
                  dateParts[1] - 1,
                  +dateParts[0]
                );
                setVoucherDate(newValue);
                const validationFlag =
                  new Date(newValue).toDateString() !== "Invalid Date" &&
                  newValue !== null &&
                  new Date(newValue).toLocaleDateString().slice(-4) >=
                    String("1970") &&
                  new Date(newValue) >= new Date("1970/01/01") &&
                  new Date(newValue).toLocaleDateString().slice(-4) <=
                    String(new Date().getFullYear()) &&
                  new Date(newValue) <=
                    new Date(dayjs(new Date()).format("MM/DD/YYYY"))
                    ? false
                    : true;
                dispatch(
                  ChequeReturnReducerAction.updateVoucherDateTouchHandler(
                    validationFlag
                  )
                );
                dispatch(
                  ChequeReturnReducerAction.updateSaveBtnDisable(validationFlag)
                );
              }}
              onChange={(newValue) => {
                setVoucherDate(newValue);
                const validationFlag =
                  new Date(newValue).toDateString() !== "Invalid Date" &&
                  newValue !== null &&
                  new Date(newValue).toLocaleDateString().slice(-4) >=
                    String("1970") &&
                  new Date(newValue) >= new Date("1970/01/01") &&
                  new Date(newValue).toLocaleDateString().slice(-4) <=
                    String(new Date().getFullYear()) &&
                  new Date(newValue) <=
                    new Date(dayjs(new Date()).format("MM/DD/YYYY"))
                    ? false
                    : true;

                dispatch(
                  ChequeReturnReducerAction.updateVoucherDateTouchHandler(
                    validationFlag
                  )
                );
                dispatch(
                  ChequeReturnReducerAction.updateSaveBtnDisable(validationFlag)
                );
              }}
            />
            {voucherDateHasError && (
              <p className="error">
                {new Date(filteredData.voucherDate).toDateString() ===
                  "Invalid Date" ||
                new Date(filteredData.voucherDate) < new Date("1970/01/01") ||
                new Date(filteredData.voucherDate) > new Date()
                  ? "Please Select Valid Voucher Date"
                  : filteredData.voucherDate === "" ||
                    filteredData.voucherDate === undefined ||
                    filteredData.voucherDate === null
                  ? "Please Select Voucher Date"
                  : ""}
              </p>
            )}
          </Grid>
        </Grid>
        <Box
          sx={{
            marginTop: "12px",
            marginBottom: "8px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Tooltip title="Ctrl+F" placement="top">
            <Button
              variant="contained"
              type="submit"
              sx={{ height: "2rem" }}
              onClick={SearchButtonHandler}
              ref={searchButtonRef}
            >
              GO
            </Button>
          </Tooltip>
          <Tooltip title="Ctrl+D" placement="top">
            <Button
              sx={{
                marginLeft: "1rem",
                color: "white",
                backgroundColor: "black",
                height: "2rem",
              }}
              onMouseOver={({ target }) => {
                target.style.backgroundColor = "black";
                target.style.color = "white";
              }}
              variant="contained"
              onClick={ClearButtonHandler}
              ref={clearRef}
            >
              Clear
            </Button>
          </Tooltip>
        </Box>
      </AccordianContainer>
      <Snackbar
        open={alert}
        autoHideDuration={3000}
        anchorOrigin={{ vertical, horizontal }}
        onClose={closeAlertHandler}
      >
        <Alert
          onClose={closeAlertHandler}
          severity={alertType}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default ChequeReturnFilter;
